import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refPmmChecklistDownloadPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={
            'PMM PM PdM プロダクトマーケティングマネージャー プロジェクトマネージャー プロダクトマネージャー GAFAM Go-to-Market戦略 SaaS グロース戦略'
          }
          image={'https://www.i3design.jp/ogp_logo.png'}
          url={'https://www.i3design.jp/download/pmmchecklist/done/'}
          title="ご入力いただきありがとうございます | PMM導入フレームワークと診断チェックリスト | 資料ダウンロード | i3DESIGN アイスリーデザイン"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
